/*!

=========================================================
* Argon Dashboard React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from 'react-dom';
// node.js library that concatenates classes (strings)
import classnames from "classnames";
// javascipt plugin for creating charts
import Chart from "chart.js";
// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";
// reactstrap components
import {
    Card,
    CardHeader,
    Row,
    Table,
    Container,
    Input,
    Button,
    InputGroup,
    Col,
    InputGroupAddon,
    InputGroupText
} from "reactstrap";


// core components
import {
  chartOptions,
  parseOptions,
  chartExample1,
  chartExample2
} from "variables/charts.jsx";

import axios from 'axios'
import Header from "components/Headers/Header.jsx";
import { Editor } from '@tinymce/tinymce-react';
import FuncoesComum from '../funcoes/FuncoesComum';
import { Link } from "react-router-dom";
import api_admin from '../services/apiadmin'
import ReactGA from 'react-ga'

class LayoutEpar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount(){

      if(!localStorage.getItem('finalidadeLocacao')){
        this.props.history.push('/admin/finalidadelocacao')
      }

       // Analytics
       ReactGA.initialize(process.env.REACT_APP_UA)
       ReactGA.pageview(window.location.pathname + window.location.search)

      // Verifica se o usuário tem acesso
      axios.get(api_admin + '/imobiliaria/imobuser').then((retorno) => {
        console.log(retorno.data.imobs.filter((e) => {
          return e.id === JSON.parse(localStorage.getItem('dadosUsuario_test')).id
        }))

        if(retorno.data.imobs.filter((e) => {
          return e.id === JSON.parse(localStorage.getItem('dadosUsuario_test')).id
        }).length === 0){
          this.props.history.push('/admin/logout')
        }
      })
      localStorage.removeItem('nomeSolidario_test')
      localStorage.removeItem('rendaSolidario_test')
      localStorage.removeItem('telefoneSolidario_test')
      localStorage.removeItem('dadoSolidario_test')
      localStorage.removeItem('nome_test')
      localStorage.removeItem('renda_test')
      localStorage.removeItem('telefone_test')
      localStorage.removeItem('dado_test')
      localStorage.removeItem('pessoasBusca_test')
      localStorage.removeItem('mask_test')
      localStorage.removeItem('maskSolidario_test')
      localStorage.removeItem('valor_test')
      localStorage.removeItem('cliente_id_test')
      localStorage.removeItem('clienteSolidario_id_test')
      localStorage.removeItem('consulta_id_test')
      localStorage.removeItem('minuto_test')
      localStorage.removeItem('email_test')
      localStorage.removeItem('aluguel_test')
      localStorage.removeItem('condominio_test')
      localStorage.removeItem('imposto_test')
      localStorage.removeItem('outros_test')
      localStorage.removeItem('luz_test')
      localStorage.removeItem('agua_test')
      localStorage.removeItem('gas_test')
      localStorage.removeItem('nomeSolidarioJF_test')
      localStorage.removeItem('rendaSolidarioJF_test')
      localStorage.removeItem('telefoneSolidarioJF_test')
      localStorage.removeItem('dadoSolidarioJF_test')
      localStorage.removeItem('nomeJF_test')
      localStorage.removeItem('rendaJF_test')
      localStorage.removeItem('telefoneJF_test')
      localStorage.removeItem('dadoJF_test')
      localStorage.removeItem('pessoasBuscaJF_test')
      localStorage.removeItem('maskJF_test')
      localStorage.removeItem('maskSolidarioJF_test')
      localStorage.removeItem('valorJF_test')
      localStorage.removeItem('cliente_idJF_test')
      localStorage.removeItem('clienteSolidario_idJF_test')
      localStorage.removeItem('consulta_idJF_test')
      localStorage.removeItem('minutoJF_test')
      localStorage.removeItem('emailJF_test')
      localStorage.removeItem('aluguelJF_test')
      localStorage.removeItem('condominioJF_test')
      localStorage.removeItem('impostoJF_test')
      localStorage.removeItem('outrosJF_test')
      localStorage.removeItem('luzJF_test')
      localStorage.removeItem('aguaJF_test')
      localStorage.removeItem('gasJF_test')
      localStorage.removeItem('activeTabPrincipalJF_test')
      localStorage.removeItem('activeTabPrincipal_test')
      localStorage.removeItem('activeTab_test')
      localStorage.removeItem('activeTabJF_test')
      localStorage.removeItem('activeTab_test')
      localStorage.removeItem('emailEnviarCartaJF_test')
      localStorage.removeItem('emailEnviarCarta_test')
      localStorage.removeItem('codigo_cartaJF_test')
      localStorage.removeItem('codigo_carta_test')
    }


  state = {
    activeNav: 1,
    chartExample1Data: "data1"
  };

  toggleNavs = (e, index) => {
    e.preventDefault();
    this.setState({
      activeNav: index,
      chartExample1Data:
        this.state.chartExample1Data === "data1" ? "data2" : "data1"
    });
    let wow = () => {
      console.log(this.state);
    };
    wow.bind(this);
    setTimeout(() => wow(), 1000);
    // this.chartReference.update();
  };

  componentWillMount() {
    if (window.Chart) {
      parseOptions(Chart, chartOptions());
    }
  }


  render() {
    return (
      <>
        <Header style={{height: '10vh'}} />
        {/* Irá selecionar qual tipo de consulta irá realizar */}
        <Container className={"mt--4 d-flex justify-content-center"} fluid style={{minHeight: '65vh'}}>
            <div className="text-center">
              <div className='float-left mt-8 p-5'>
                <i className={"ni ni-single-02 text-white p-5 rounded-circle" + FuncoesComum.solida()} style={{fontSize: '5em'}}/>
                <div className={"mt-3 p-2"} style={{fontSize: '1.5em', fontWeight: 'bold'}}>
                  Pessoa Física
                </div>
                <div className={"mt-3 text-center"} style={{width: '40vh'}}>
                  Selecione essa opção para consultar pessoas físicas através de documentos ou número de CPF.
                </div>
                <div className={"mt-4 text-center"} style={{width: '40vh'}}>
                  <Button className={'w-50' + FuncoesComum.solida()} style={{color: 'white'}} to='/admin/pessoafisica' tag={Link}>Avançar</Button>
                </div>
              </div>
              <div className='float-left m-5 p-5 d-none d-xl-block ocultarDivSeparador' style={{fontSize: '1.2em', fontWeight: 'bold'}}>
                <hr style={{border: 'none', borderLeft: '1px solid', height: '22vh', width: '1px'}} />
                OU
                <hr style={{border: 'none', borderLeft: '1px solid', height: '22vh', width: '1px'}} />
              </div>
              <div className='float-left mt-8 p-5'>
                <i className={"ni ni-building text-white p-5 rounded-circle" + FuncoesComum.solida()} style={{fontSize: '5em'}}/>
                <div className={"mt-3 p-2"} style={{fontSize: '1.5em', fontWeight: 'bold'}}>
                  Pessoa Jurídica
                </div>
                <div className={"mt-3 text-center"} style={{width: '40vh'}}>
                  Selecione essa opção para consultar pessoas jurídicas através do número de CNPJ informado.
                </div>
                <div className={"mt-4 text-center"} style={{width: '40vh'}}>
                  <Button className={'w-50' + FuncoesComum.solida()} style={{color: 'white'}} to='/admin/pessoajuridica' tag={Link}>Avançar</Button>
                </div>
              </div>
            </div>
        </Container>
      </>
    );
  }
}

export default LayoutEpar;
